// extracted by mini-css-extract-plugin
export default {"user_container":"UserInfo_user_container__QKaO7","name":"UserInfo_name__8tR9g","place":"UserInfo_place__5FQmR"};